/**
 * Os passos ao vivo de um turno, na forma que a bolha desenha.
 *
 * Desde a consoleai#24893 o stream diz QUEM deu cada passo: `atendente` (as
 * ferramentas do @Atendente) ou um especialista (`devops`, `dba` — o que a porta
 * dele rodou por dentro), e `tool_fim` quando o especialista terminou. A bolha
 * mostra os passos de dentro recuados sob a linha da porta (spec 2026-10-09 §4
 * F1.1; o @DBA, spec 2026-10-30-agente-dba §4.2).
 */
import { eEspecialista, type Especialista } from './toolLabels'

export type AgenteDoPasso = 'atendente' | Especialista

export interface PassoAoVivo {
  name: string
  agente: AgenteDoPasso
  /** Só na linha da porta de um especialista: ele já respondeu. */
  fim?: boolean
}

export interface EventoDePasso {
  type: 'tool' | 'tool_fim'
  name: string
  agente?: string
}

export function aplicarEventoDePasso(passos: PassoAoVivo[], ev: EventoDePasso): PassoAoVivo[] {
  if (ev.type === 'tool') {
    // Agente que o front não conhece vale como do @Atendente: o passo aparece, sem recuo.
    return [...passos, { name: ev.name, agente: eEspecialista(ev.agente) ? ev.agente : 'atendente' }]
  }
  // `tool_fim`: marca a consulta mais recente ainda aberta.
  for (let i = passos.length - 1; i >= 0; i--) {
    const p = passos[i]
    if (p.agente === 'atendente' && p.name === ev.name && !p.fim) {
      const novo = passos.slice()
      novo[i] = { ...p, fim: true }
      return novo
    }
  }
  return passos
}

/** Agrupa: cada passo do @Atendente com os passos de especialista que vieram logo depois. */
export function agruparPassos(passos: PassoAoVivo[]): { passo: PassoAoVivo; dentro: PassoAoVivo[] }[] {
  const grupos: { passo: PassoAoVivo; dentro: PassoAoVivo[] }[] = []
  for (const p of passos) {
    if (p.agente !== 'atendente' && grupos.length > 0) grupos[grupos.length - 1].dentro.push(p)
    else grupos.push({ passo: p, dentro: [] })
  }
  return grupos
}
